import React from 'react'
import PrivacyContainer from '../containers/Legal/Privacy.container'

const Privacy = () => <PrivacyContainer />

export default Privacy
